
import { Component, Prop } from 'vue-property-decorator';
import SliderBase from '@/ui/components/devices/devices/base/SliderBase.vue';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import PushButtonBase from '@/ui/components/devices/devices/base/PushButtonBase/index.vue';
import InputFieldBase from '@/ui/components/devices/devices/base/InputFieldBase.vue';
import ArrowInBase from '@/ui/components/devices/devices/base/ArrowInBase.vue';
import ArrowOutBase from '@/ui/components/devices/devices/base/ArrowOutBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { mixins } from 'vue-class-component';
import { Validation } from '@/ui/mixins/validation';
import { State, Action } from 'vuex-class';
import { IVariablesState } from '@/store/modules/measurements/types';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent ControlAwning device
 */
@Component({
  components: {
    SliderBase,
    OutputFieldBase,
    PushButtonBase,
    InputFieldBase,
    ArrowInBase,
    ArrowOutBase,
    DeviceLayout,
    LabelUnitWrapper,
  },
})
export default class ControlAwning extends mixins(Validation) {
  @Prop() deviceData!: IDevice;
  @State('measurements') measurementsState!: IVariablesState;

  get langPath() {
    return `devices.${this.deviceData.data.type}`;
  }

  get measurements() {
    return this.measurementsState.measurements;
  }
  get sliderActualValue() {
    return this.measurements.get(this.deviceData.data.mappings.OutputField_actualValue);
  }
}
